import { View, TouchableOpacity, Text, Image, StyleSheet } from "react-native"
import { FONT_STYLE } from "../../dataSchema/const"

const ResultPopUpFail = ({requestClose})=>{
    return(
        <View style={styles.popup}>
          <Image style={styles.image} source={require('../../assets/Fail.png')}></Image>
          <Text style={styles.popupText}>{'Oops, khảo sát thất bại'}</Text>
          <Text style={styles.contentText}>{'Mọi thứ vẫn ổn, trừ trang này Hẹn bạn ở khảo sát sau của TAPTAP'}</Text>
          <TouchableOpacity
            style={styles.closeButton}
            onPress={requestClose}
          >
            <Text style={styles.closeButtonText}>Hiểu rồi nha</Text>
          </TouchableOpacity>
        </View>
    )
}

const styles = StyleSheet.create({
    image:{
        width:183,
        height:130,
        top:-55
    },
    popup: {
        width: 343,
        height: 298,
        backgroundColor: '#FFFFFF',
        borderRadius: 10,
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
      },
      popupText: {
        fontSize: 22,
        fontFamily:FONT_STYLE.BOLD,
        width:'80%',
        textAlign:'center',
        top:-30
      },
      contentText:{
        fontSize: 16,
        fontFamily:FONT_STYLE.MEDIUM,
        textAlign:'center',
        width:'80%',
      },
      closeButton: {
        paddingVertical: 10,
        paddingHorizontal: 20,
        borderRadius: 5,
        borderWidth:1,
        borderColor:'#888888',
        width:'90%',
        position:'absolute',
        bottom:25
      },
      closeButtonText: {
        color: '#000000',
        fontSize: 16,
        fontFamily:FONT_STYLE.BOLD,
        textAlign:'center'
      },
})
export default ResultPopUpFail